/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationSettingsSettingsInApp } from './NotificationSettingsSettingsInApp';
import {
    NotificationSettingsSettingsInAppFromJSON,
    NotificationSettingsSettingsInAppFromJSONTyped,
    NotificationSettingsSettingsInAppToJSON,
    NotificationSettingsSettingsInAppToJSONTyped,
} from './NotificationSettingsSettingsInApp';
import type { NotificationSettingsSettingsEmail } from './NotificationSettingsSettingsEmail';
import {
    NotificationSettingsSettingsEmailFromJSON,
    NotificationSettingsSettingsEmailFromJSONTyped,
    NotificationSettingsSettingsEmailToJSON,
    NotificationSettingsSettingsEmailToJSONTyped,
} from './NotificationSettingsSettingsEmail';

/**
 * Updated notification preferences by platform and resource type
 * @export
 * @interface UpdateNotificationSettingsRequestSettings
 */
export interface UpdateNotificationSettingsRequestSettings {
    /**
     * 
     * @type {NotificationSettingsSettingsInApp}
     * @memberof UpdateNotificationSettingsRequestSettings
     */
    inApp: NotificationSettingsSettingsInApp;
    /**
     * 
     * @type {NotificationSettingsSettingsEmail}
     * @memberof UpdateNotificationSettingsRequestSettings
     */
    email: NotificationSettingsSettingsEmail;
}

/**
 * Check if a given object implements the UpdateNotificationSettingsRequestSettings interface.
 */
export function instanceOfUpdateNotificationSettingsRequestSettings(value: object): value is UpdateNotificationSettingsRequestSettings {
    if (!('inApp' in value) || value['inApp'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UpdateNotificationSettingsRequestSettingsFromJSON(json: any): UpdateNotificationSettingsRequestSettings {
    return UpdateNotificationSettingsRequestSettingsFromJSONTyped(json, false);
}

export function UpdateNotificationSettingsRequestSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateNotificationSettingsRequestSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'inApp': NotificationSettingsSettingsInAppFromJSON(json['inApp']),
        'email': NotificationSettingsSettingsEmailFromJSON(json['email']),
    };
}

export function UpdateNotificationSettingsRequestSettingsToJSON(json: any): UpdateNotificationSettingsRequestSettings {
    return UpdateNotificationSettingsRequestSettingsToJSONTyped(json, false);
}

export function UpdateNotificationSettingsRequestSettingsToJSONTyped(value?: UpdateNotificationSettingsRequestSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inApp': NotificationSettingsSettingsInAppToJSON(value['inApp']),
        'email': NotificationSettingsSettingsEmailToJSON(value['email']),
    };
}

